import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import optinlyLogo from '../../images/optinly-icon.png'
import chainImage from '../../images/integration-pages/chain.png'
import vs from '../../images/integration-pages/vs.png'


const ProductLogo = ({
    otherProductLogo,
    integrationApp,
    isComparisionPage
}) => {

    return (
        <>
            <div className="w-full md:w-3/4 lg:w-full mx-auto px-4 xs:px-7 md:px-14 lg:px-20 flex flex-col sm:flex-row items-center sm:justify-between space-x-2 space-y-4 sm:space-y-0">
                <div className="flex flex-row space-x-2 md:space-x-4 items-center">
                    <img src={optinlyLogo} alt="Optinly Logo" className="w-7 h-7 lg:w-9 lg:h-9" />
                    <div className="font-semibold text-2xl md:text-28px lg:text-32px text-font_secondary">Optinly</div>
                </div>

                <div className="">
                    {isComparisionPage ? 
                        <img src={vs} alt="Versus Image" className="w-14 h-14 lg:w-24 lg:h-28" />
                        :
                        <img src={chainImage} alt="Chian Image" className="w-9 h-9 lg:w-12 lg:h-12" />
                    }

                </div>

                <div className="flex flex-row space-x-2 md:space-x-4 items-center">
                    <img src={otherProductLogo} alt="Logo" className="w-7 h-7 lg:w-10 lg:h-10" />
                    <div className="font-semibold text-2xl md:text-28px lg:text-32px text-font_secondary capitalize">{integrationApp}</div>
                </div>
            </div>
            
        </>
    )
}

export default ProductLogo
